var _path, _path2, _path3, _path4, _g, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdditionalDocumentCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.00073 8.73646V5.73521C6.00073 4.63018 6.89654 3.73438 8.00157 3.73438H15.1766C15.7072 3.73438 16.216 3.94536 16.5911 4.32062L19.4203 7.1498C19.7956 7.52494 20.0066 8.03378 20.0066 8.56439V19.741C20.0066 20.8461 19.1108 21.7419 18.0057 21.7419H8.00157C6.89654 21.7419 6.00073 20.8461 6.00073 19.741V18.7406",
    fill: "#3158F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.00073 8.73646V5.73521C6.00073 4.63018 6.89654 3.73438 8.00157 3.73438H15.1766C15.7072 3.73438 16.216 3.94536 16.5911 4.32062L19.4203 7.1498C19.7956 7.52494 20.0066 8.03378 20.0066 8.56439V19.741C20.0066 20.8461 19.1108 21.7419 18.0057 21.7419H8.00157C6.89654 21.7419 6.00073 20.8461 6.00073 19.741V18.7406V8.73646Z",
    stroke: "#3158F2",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8878_3118",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 2,
    width: 16,
    height: 21
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.00073 8.73646V5.73521C6.00073 4.63018 6.89654 3.73438 8.00157 3.73438H15.1766C15.7072 3.73438 16.216 3.94536 16.5911 4.32062L19.4203 7.1498C19.7956 7.52494 20.0066 8.03378 20.0066 8.56439V19.741C20.0066 20.8461 19.1108 21.7419 18.0057 21.7419H8.00157C6.89654 21.7419 6.00073 20.8461 6.00073 19.741V18.7406",
    fill: "#848484"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.00073 8.73646V5.73521C6.00073 4.63018 6.89654 3.73438 8.00157 3.73438H15.1766C15.7072 3.73438 16.216 3.94536 16.5911 4.32062L19.4203 7.1498C19.7956 7.52494 20.0066 8.03378 20.0066 8.56439V19.741C20.0066 20.8461 19.1108 21.7419 18.0057 21.7419H8.00157C6.89654 21.7419 6.00073 20.8461 6.00073 19.741V18.7406V8.73646Z",
    stroke: "#848484",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8878_3118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.56323 15.1784H14.981",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.56323 18.3872H11.7721",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.0106 8.73597H16.009C15.4564 8.73597 15.0085 8.28807 15.0085 7.73555V1.73389",
    fill: "#91A5F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0106 8.73597H16.009C15.4564 8.73597 15.0085 8.28807 15.0085 7.73555V1.73389",
    stroke: "#91A5F2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.00073,
    y: 5.73779,
    width: 4,
    height: 4,
    rx: 0.8,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdditionalDocumentCheck);
export default __webpack_public_path__ + "static/media/additional_document_check.4bc978354ad61e9b6436fd100022c7f5.svg";
export { ForwardRef as ReactComponent };